import { pt } from "../../../../date-fns/locale/pt.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    pt
  }
};